import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IModificationsClient, IProjectsClient, ModificationsClient, ProjectsClient } from "app/ApiClient";
import { EncodedDataClient, IEncodedDataClient } from "app/SharedApiClient";
import { initialProjectSelectorState } from "./projectSelectorState";

const projectsClient: IProjectsClient = new ProjectsClient(process.env.REACT_APP_API_URL);
const encodedDataClient: IEncodedDataClient = new EncodedDataClient(process.env.REACT_APP_SHARED_API_URL);
const modificationsClient: IModificationsClient = new ModificationsClient(process.env.REACT_APP_API_URL);

export const getAllProjects = createAsyncThunk("projectSelector/getAllProjects", async (_, { rejectWithValue }) => {
  try {
    const result = await projectsClient.getAllProjects();
    return result;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getProjectSelectorVersions = createAsyncThunk(
  "projectSelector/getProjectSelectorVersions",
  async ({ projectId, source }: { projectId: string; source: string }, { rejectWithValue }) => {
    try {
      const result = await encodedDataClient.getEncodedVersions(projectId, source);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const getProjectSelectorModifications = createAsyncThunk(
  "projectSelector/getProjectSelectorModifications",
  async ({ projectId, versionId }: { projectId: number; versionId: string }, { rejectWithValue }) => {
    try {
      const result = await modificationsClient.getByProjectId(projectId, versionId);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const projectSelectorSlice = createSlice({
  name: "projectSelector",
  initialState: initialProjectSelectorState,
  reducers: {
    resetProjectSelector: () => initialProjectSelectorState,
    resetProjectSelectorVersions: (state) => {
      state.versions = [];
      state.versionsLoading = LoadingState.idle;
    },
    resetProjectSelectorModifications: (state) => {
      state.modifications = [];
      state.modificationsLoading = LoadingState.idle;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllProjects.pending, (state) => {
      state.loading = LoadingState.pending;
      state.projects = [];
      state.modifications = [];
      state.versions = [];
    });
    builder.addCase(getAllProjects.fulfilled, (state, { payload }) => {
      state.loading = LoadingState.succeed;
      state.projects = payload.map((row) => ({
        ...row,
        upperOriginProjectId: row.originProjectId.toUpperCase(),
        upperProjectName: row.name?.toUpperCase(),
      }));
    });
    builder.addCase(getAllProjects.rejected, (state) => {
      state.loading = LoadingState.failed;
    });

    builder.addCase(getProjectSelectorVersions.pending, (state) => {
      state.modifications = [];
      state.versionsLoading = LoadingState.pending;
      state.versions = [];
    });
    builder.addCase(getProjectSelectorVersions.fulfilled, (state, { payload }) => {
      state.versionsLoading = LoadingState.succeed;
      state.versions = payload;
    });
    builder.addCase(getProjectSelectorVersions.rejected, (state) => {
      state.versionsLoading = LoadingState.failed;
    });
    // getProjectSelectorModifications
    builder.addCase(getProjectSelectorModifications.pending, (state) => {
      state.modifications = [];
      state.modificationsLoading = LoadingState.pending;
    });
    builder.addCase(getProjectSelectorModifications.fulfilled, (state, { payload }) => {
      state.modifications = payload;
      state.modificationsLoading = LoadingState.succeed;
    });
    builder.addCase(getProjectSelectorModifications.rejected, (state) => {
      state.modificationsLoading = LoadingState.failed;
    });
  },
});
export const { resetProjectSelector, resetProjectSelectorVersions, resetProjectSelectorModifications } =
  projectSelectorSlice.actions;
export default projectSelectorSlice.reducer;
